import Image from 'next/image';

type Props = {
  width?: number;
  height?: number;
};

const gladeImgSrc = '/glade-logo.png';

const Noodle: React.FC<Props> = ({ width = 24, height = 24 }) => (
  <Image src={gladeImgSrc} width={width || 24} height={height || 24} alt='Logo' />
);

export { gladeImgSrc };

export default Noodle;
